<template>
	<div class="admin-page-group">
		<div class="admin-page-header">
			Скачать отчёты
		</div>
		<div class="admin-page-description">
			<VButton
				v-for="report in reports"
				:key="report.rpcMethod"
				theme="link"
				@click="downloadReport(report.rpcMethod)"
			>
				<template #icon>
					<VIcon material="file_download" />
				</template>
				{{ report.title }}
			</VButton>
		</div>
	</div>
</template>

<style lang="scss" src="./ReportsList.scss" />

<script lang="ts">

import ReportsService from '@/domains/Reports/ReportsService';

export default defineComponent({
	name: 'ReportsList',

	data() {
		return {
			reports: ReportsService.reportsList(),
		};
	},

	methods: {
		/**
		 * Запускает скачивание выбранного отчёта
		 */
		async downloadReport(rpcMethod: string): Promise<void> {
			await ReportsService.download(rpcMethod);
		},
	},
});
</script>
